<template>
<div>
  <v-text-field data-operator="name"
      v-model="operator.name" 
      label="Operator name" 
      required>
  </v-text-field>
  <v-text-field data-operator="address"
      v-model="operator.address" 
      label="Operator address" 
      required>
  </v-text-field>
   <v-text-field data-operator="phone"
      v-model="operator.phone" 
      label="Phone" 
      required>
   </v-text-field>
  <v-text-field data-operator="email"
      v-model="operator.email" 
      label="Operator email" 
      required>
  </v-text-field>
  <v-text-field data-operator="title"
      v-model="operator.title" 
      label="Operator title" 
      required>
  </v-text-field>
  <v-text-field data-operator="contact"
      v-model="operator.contact" 
      label="Contact person" 
      required>
  </v-text-field>
  <v-text-field data-operator="communication"
      v-model="operator.communication" 
      label="Contact email" 
      required>
  </v-text-field>
</div>
</template>

<script>
export default {
  data: () => ({
      corporation : false
  }),
  props: ["operator"],
  computed: {},
  methods: {}
};
</script>

<style>
</style>
